import React from 'react'
import AboutMe from './components/Experties/AboutMe'
import Footer from './components/Footer/Footer'
import Header from './components/Header/Header'
import Hero from './components/Hero/Hero'
import People from './components/People/People'
import Portfolio from './components/Portfolio/Portfolio'
import Work from './components/Work/Work'
import css from './styles/App.module.scss'



const Main = () => {
  //don't forget to add font link in index.html
  return (
    <div className={`bg-primary ${css.container}`}>
      <Header/>
      <Hero/>
      <AboutMe/>
      <Work/>
      <Portfolio/>
      <People/>
   
      <Footer/>
    </div>
  )
}

export default Main